<template>
    <b-modal title="Add stay" v-model="addModalActive" no-close-on-backdrop>
        <template #default>
            <b-form-group>
                <label>ERP Id:<fa class="ml-1" icon="question-circle" v-b-tooltip="'Guest ID from management software'"/></label>
                <b-form-input
                    type="text"
                    placeholder="ERP Id"
                    v-model="addObject.erp_id"
                />
            </b-form-group>
            <b-form-group>
                <label>Name:</label>
                <b-form-input
                    type="text"
                    placeholder="Name"
                    v-model="addObject.name"
                />
            </b-form-group>
            <b-form-group>
                <b-form-checkbox v-model="addObject.show_welcome_screen">Show welcome screen</b-form-checkbox>
            </b-form-group>
            <b-form-group>
                <label>Check in:</label>
                <flat-pickr
                    v-model="addObject.check_in"
                    class="form-control"
                    :config="{ enableTime: true, dateFormat: 'Y-m-d H:i', time_24hr: true}"
                />
            </b-form-group>
            <b-form-group>
                <label>Check out:</label>
                <flat-pickr
                    v-model="addObject.check_out"
                    class="form-control"
                    :config="{ enableTime: true, dateFormat: 'Y-m-d H:i', time_24hr: true}"
                />
            </b-form-group>
            <b-form-group>
                <label>Room:</label>
                <v-select
                    v-model="addObject.room_id"
                    :reduce="room => room.id"
                    :filter="filterRooms"
                    label="name"
                    :options="rooms"
                >
                    <template slot="option" slot-scope="room">
                        <span>{{room.location + ' - ' + room.name}}</span>
                    </template>

                    <template slot="selected-option" slot-scope="room">
                        <span>{{room.location + ' - ' + room.name}}</span>
                    </template>
                </v-select>
            </b-form-group>
            <b-form-group>
                <label>Language:</label>
                <v-select
                    v-model="addObject.language_id"
                    :reduce="language => language.id"
                    :filter="filterLanguages"
                    label="name"
                    :options="languages"
                >
                    <template slot="option" slot-scope="language">
                        <img v-if="language.icon && language.icon.length > 0" :src="'/api/management/v1/image/' + language.icon" style="max-width: 100%; max-height: 15px;" class="rounded-sm mr-1" alt="Image"/>
                        <span>{{language.name}}</span>
                    </template>

                    <template slot="selected-option" slot-scope="language">
                        <img v-if="language.icon && language.icon.length > 0" :src="'/api/management/v1/image/' + language.icon" style="max-width: 100%; max-height: 15px;" class="rounded-sm mr-1" alt="Image"/>
                        <span>{{language.name}}</span>
                    </template>
                </v-select>

            </b-form-group>
        </template>
        <template #modal-footer>
            <b-button variant="danger" @click="addModalActive = false">
                <feather-icon
                    icon="XIcon"
                    class="mr-50"
                />
                <span class="align-middle">Close</span>
            </b-button>

            <b-button variant="primary" @click="addStay">
                <feather-icon
                    icon="PlusIcon"
                    class="mr-50"
                />
                <span class="align-middle">Add</span>
            </b-button>
        </template>
    </b-modal>
</template>
<script>

    import {BButton, BFormGroup, BFormInput, BModal, BFormCheckbox} from 'bootstrap-vue'
    import vSelect from 'vue-select'
    import flatPickr from 'vue-flatpickr-component'

    export default {
        components: {
            BButton,
            BModal,
            BFormInput,
            BFormGroup,
            BFormCheckbox,
            flatPickr,
            vSelect
        },
        props: {
            rooms: {
                type: Array,
                required: true
            },
            languages: {
                type: Array,
                required: true
            }
        },
        data() {
            return {
                addObject: {
                    name: '',
                    erp_id: '',
                    show_welcome_screen: true,
                    language_id: '',
                    check_in: null,
                    check_out: null
                },
                addModalActive: false
            }
        },
        methods: {
            open() {
                this.addModalActive = true
            },
            addStay() {
                const thisIns = this

                const loadPromise = this.$http.post('/api/management/v1/stay', {
                    name: this.addObject.name,
                    erp_id: this.addObject.erp_id,
                    show_welcome_screen: this.addObject.show_welcome_screen,
                    room_id: this.addObject.room_id,
                    language_id: this.addObject.language_id,
                    check_in: this.moment(this.addObject.check_in).format(),
                    check_out: this.moment(this.addObject.check_out).format()
                })
                loadPromise.then(function(response) {
                    thisIns.$printSuccess('Stay added')
                    thisIns.addModalActive = false
                    thisIns.addObject = {}
                    thisIns.$emit('stayAdded', response.data.id)
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })
            },
            filterRooms(rooms, search) {
                return rooms.filter(room => room.location.toLowerCase().includes(search.toLowerCase()) || room.name.toLowerCase().includes(search.toLowerCase()))
            },
            filterLanguages(languages, search) {
                return languages.filter(language => language.name.toLowerCase().includes(search.toLowerCase()))
            }
        }
    }
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>